/**
 * `h()` — React's createElement with the children spread, so components are plain TypeScript.
 *
 * Why not JSX: the repository runs its tests with `node --experimental-strip-types`, which strips
 * types and nothing else. JSX would need a second toolchain for the one package that used it.
 * `h("span", { className: "oc-m2" }, "A$47,000")` reads like the console prototype's `el()` and
 * renders under node --test and Vite alike.
 */
import { createElement, type ElementType, type ReactNode, type ComponentProps, type Key } from "react";
export type { ReactNode };

export function h<T extends ElementType>(
  type: T,
  props?: (ComponentProps<T> & { key?: Key }) | null,
  ...children: ReactNode[]
): ReactNode {
  return createElement(type, props ?? null, ...children);
}

/** Class joiner that drops falsy parts, so a conditional class reads as one line. */
export const cx = (...parts: Array<string | false | null | undefined>): string => parts.filter(Boolean).join(" ");
